var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-x-mark-circle';
                    var viewUrl = 'gfx/sprite.svg#view-icon-x-mark-circle';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 512 512',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };